import { render, staticRenderFns } from "./StyleCommentsEvent.vue?vue&type=template&id=012f077e&scoped=true&"
import script from "./StyleCommentsEvent.vue?vue&type=script&lang=js&"
export * from "./StyleCommentsEvent.vue?vue&type=script&lang=js&"
import style0 from "./StyleCommentsEvent.vue?vue&type=style&index=0&id=012f077e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f077e",
  null
  
)

export default component.exports